import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9790b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "memory-matrix__top-spacing" }, null, -1))
const _hoisted_2 = { class: "memory-matrix__instruction" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_matrix_display = _resolveComponent("game-matrix-display")!
  const _component_countdown_bar = _resolveComponent("countdown-bar")!
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Memory Matrix",
    name: "MemoryMatrix",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    points: _ctx.gamePoints,
    "action-buttons": _ctx.currentActionButtons,
    onSubmitMatrix: _ctx.submitMatrix,
    onPrecountdownOver: _ctx.startMemorizeCountdown,
    onRestart: _ctx.restart
  }, {
    top: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.currentInstruction), 1),
      _createVNode(_component_game_matrix_display, {
        class: "memory-matrix__game-matrix",
        matrix: _ctx.currentMatrix,
        "spaced-items": true,
        "max-width": _ctx.maxMatrixDisplayWidth,
        onItemClick: _ctx.handleItemClick
      }, null, 8, ["matrix", "max-width", "onItemClick"]),
      (_ctx.gamePhase < 2)
        ? (_openBlock(), _createBlock(_component_countdown_bar, {
            key: 0,
            class: "memory-matrix__countdown",
            countdown: _ctx.currentCountdown,
            "is-small": true
          }, null, 8, ["countdown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "points", "action-buttons", "onSubmitMatrix", "onPrecountdownOver", "onRestart"]))
}